<template>
  <nav class="navBar center">
    <!-- LOCKED -->
    <NavVaccine v-if="vaccineStatus !== 'Unlocked'" />

    <!-- UNLOCKED -->
    <div v-if="vaccineStatus === 'Unlocked'" class="nav">
      <div
        class="production center"
        :class="{ active: isActive === 'Prod' }"
        @click="click('Prod')"
      >
        <img src="@/assets/img/nav-prod.svg" alt="Production" />
      </div>

      <div
        class="medicine center"
        :class="{ active: isActive === 'Med' }"
        @click="click('Med')"
      >
        <transition name="fade">
          <Tooltip
            :tWidth="320"
            :tBottom="72"
            :avatar="true"
            :hand="false"
            v-if="$store.state.tutStep === 6"
            v-click-outside="tooltipStepOut"
            >New production is available!</Tooltip
          >
        </transition>
        <img src="@/assets/img/vaccine.svg" alt="Medicine" />
      </div>
    </div>
  </nav>
</template>

<script>
import NavVaccine from "@/components/NavVaccine.vue";
import Tooltip from "@/components/Tooltip.vue";

export default {
  name: "Navigation",
  components: { NavVaccine, Tooltip },
  props: {},
  computed: {
    vaccineStatus: function() {
      return this.$store.state.vaccineStatus;
    },
  },
  data() {
    return {
      isActive: "Prod",
      showTooltip: false,
    };
  },

  mounted: function() {},

  methods: {
    click: function(string) {
      this.isActive = string;
      this.$emit("click", string);
      this.$store.commit("tabToggle");
    },

    tooltipStepOut: function() {
      console.log("here");
      this.$store.commit("plusTutStep"); // 8
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "@/assets/scss/vars.scss";
.navBar {
  width: 100%;
  position: fixed;
  bottom: 0;
  display: flex;
  background: #fff;
  border-top: 4px solid $gray300;

  .nav {
    display: flex;
    width: 100%;
    > div {
      position: relative;
      width: 50%;
    }
  }

  div {
    // width: 50%;
    border-radius: 12px;
    padding: 6px;
    color: $gray800;
    transition: all 0.2s;
    img {
      max-height: 48px;
      margin-bottom: 4px;
      opacity: 0.85;
      filter: grayscale(50%);
      transition: all 0.2s;
    }
  }

  .active {
    background: $gray300;

    img {
      filter: grayscale(0%);
      opacity: 1;
    }

    span {
      color: $black;
      font-weight: 600;
    }
  }
}
</style>
